import ZlbConfirm from '@/components/ZlbConfirm';
import { reqReimburseType } from 'src/services/user';
import {
  cancelProjectRelation,
  getNoRelationProjectList,
  getRelationProjectList,
  importRelationSubmit,
  relationProjects,
  reqBudgetDetail,
  reqOrgEconomicSubjectList,
} from '../services';

const responseErrorHandle = res => {
  const { success, message, statusText } = res;
  if (!success) {
    ZlbConfirm({
      title: message || statusText,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
  return success;
};

export default {
  namespace: 'orgEconomicSubject',
  state: {
    reimburseTypeList: [],
    detail: {},
  },
  effects: {
    *getReimburseType({ payload }, { call, put }) {
      const res = yield call(reqReimburseType, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          reimburseTypeList: res?.result || [],
        },
      });
    },

    *getOrgEconomicSubjectList({ payload }, { call }) {
      const res = yield call(reqOrgEconomicSubjectList, payload);
      responseErrorHandle(res);
      return res;
    },

    *getBudgetDetail({ payload }, { call, put }) {
      const res = yield call(reqBudgetDetail, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          detail: res.result || [],
        },
      });
      return res;
    },

    *getRelationProjectList({ payload }, { call, put }) {
      const res = yield call(getRelationProjectList, payload);
      return res;
    },

    *cancelProjectRelation({ payload }, { call, put }) {
      const res = yield call(cancelProjectRelation, payload);
      return res;
    },

    *getNoRelationProjectList({ payload }, { call, put }) {
      const res = yield call(getNoRelationProjectList, payload);
      return res;
    },

    *relationProjects({ payload }, { call, put }) {
      const res = yield call(relationProjects, payload);
      return res;
    },

    *importRelationSubmit({ payload }, { call }) {
      const res = yield call(importRelationSubmit, payload);
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
